import { NavLink } from 'react-router-dom';
import { LayoutDashboard, FileText, Users, UserCheck, Wallet, LogOut } from 'lucide-react';
import { authService } from '../../services/authService';

const navigation = [
  { name: 'Панель управления', href: '/admin', icon: LayoutDashboard },
  { name: 'Посты', href: '/admin/posts', icon: FileText },
  { name: 'Сотрудники', href: '/admin/workers', icon: Users },
  { name: 'Пользователи', href: '/admin/users', icon: UserCheck },
  { name: 'Взносы', href: '/admin/membership', icon: Wallet },
];

export default function Sidebar() {
  const handleLogout = () => {
    authService.logout();
    window.location.href = '/admin/login';
  };

  return (
    <div className="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-64 lg:flex-col">
      <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-primary-800 px-6 pb-4">
        <div className="flex h-16 shrink-0 items-center">
          <span className="text-xl font-bold text-white">Zhasyl Zhelken</span>
        </div>
        <nav className="flex flex-1 flex-col">
          <ul className="flex flex-1 flex-col gap-y-7">
            <li>
              <ul className="-mx-2 space-y-1">
                {navigation.map((item) => (
                  <li key={item.name}>
                    <NavLink
                      to={item.href}
                      end={item.href === '/admin'}
                      className={({ isActive }) =>
                        `group flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 ${
                          isActive
                            ? 'bg-primary-700 text-white'
                            : 'text-primary-200 hover:bg-primary-700 hover:text-white'
                        }`
                      }
                    >
                      <item.icon className="h-6 w-6 shrink-0" aria-hidden="true" />
                      {item.name}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </li>
            <li className="mt-auto">
              <button
                onClick={handleLogout}
                className="group -mx-2 flex w-full gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-primary-200 hover:bg-primary-700 hover:text-white"
              >
                <LogOut className="h-6 w-6 shrink-0" aria-hidden="true" />
                Выйти
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}
